import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { StoreAPI } from "@/lib/storeApi";

const TOKEN_KEY = "vornx-token";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown/none
  const [loading, setLoading] = useState(true);

  const hydrate = useCallback(async () => {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await StoreAPI.me();
      setUser(me);
    } catch (_) {
      window.localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    hydrate();
  }, [hydrate]);

  const login = async (email, password) => {
    const data = await StoreAPI.login({ email, password });
    window.localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const data = await StoreAPI.register({ name, email, password });
    window.localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    window.localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };

  const refreshUser = useCallback(async () => {
    const me = await StoreAPI.me();
    setUser(me);
    return me;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin: user?.role === "admin", isStaff: ["admin", "operator", "editor"].includes(user?.role), isEditor: user?.role === "editor", login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
